import Plot from "react-plotly.js";
import { useTheme } from "../../theme/useTheme";

const HeatmapWithLegend = (props: any) => {
  const { mode } = useTheme();

  return (
    <div style={{ width: "100%", height: "250px" }}>
      <Plot
        layout={{
          autosize: true,
          showlegend: true,
          paper_bgcolor: "rgba(0,0,0,0)",
          plot_bgcolor: "rgba(0,0,0,0)",
          modebar: {
            bgcolor: "rgba(0,0,0,0)",
            color: mode === "dark" ? "#9ca3af" : "#6b7280",
            activecolor: mode === "dark" ? "#e5e7eb" : "#111827",
          },
          legend: {
            x: 1.02,
            y: 1,
            xanchor: "left",
            yanchor: "top",
            bgcolor: "rgba(0,0,0,0)",
            bordercolor: "rgba(0,0,0,0)",
            font: {
              size: 12,
              color: mode === "dark" ? "#e5e7eb" : "#374151",
            },
          },
          xaxis: {
            side: "bottom",
            tickangle: -90,
            tickfont: {
              size: 12,
              color: mode === "dark" ? "#d1d5db" : "#374151",
            },
            showgrid: false,
            zeroline: false,
            ticks: "",
          },
          yaxis: {
            showticklabels: false,
            showgrid: false,
            zeroline: false,
            ticks: "",
          },
          margin: { l: 10, r: 50, t: 60, b: 120 },
        }}
        data={[
          {
            type: "heatmap" as const,
            hoverongaps: false,
            z: props.zaxisvalues,
            x: props.xaxisvalues,
            y: props.yaxisvalues,
            zmin: 0,
            zmax: 1,
            xgap: 2,
            ygap: 2,
            colorscale: [
              [0, "#d3d3d3"],
              [1, "#1abc9c"],
            ],
            showscale: false,
            hovertemplate: "<b>%{x}</b><br>Value: %{z:.2f}<extra></extra>",
            showlegend: false,
          },
          // Legend trace for "In KG"
          {
            type: "scatter" as const,
            mode: "markers",
            x: [null],
            y: [null],
            marker: {
              size: 12,
              color: "#1abc9c",
            },
            name: "In KG",
            showlegend: true,
            hoverinfo: "none",
          },
          // Legend trace for "Not in KG"
          {
            type: "scatter" as const,
            mode: "markers",
            x: [null],
            y: [null],
            marker: {
              size: 12,
              color: "#d3d3d3",
              line: {
                color: "#999999",
                width: 1,
              },
            },
            name: "Not in KG",
            showlegend: true,
            hoverinfo: "none",
          },
        ]}
        config={{
          responsive: true,
          displayModeBar: true,
          displaylogo: false,
          modeBarButtons: [["toImage"]],
          modeBarButtonsToRemove: [
            "zoomIn2d",
            "zoomOut2d",
            "resetScale2d",
            "lasso2d",
            "select2d",
            "hoverClosestCartesian",
            "hoverCompareCartesian",
            "sendDataToCloud",
          ],
          toImageButtonOptions: {
            format: "png",
            filename: `${props.title.split(" ").join("_")}_heatmap`,
          },
        }}
        style={{ width: "100%", height: "100%" }}
        useResizeHandler={true}
      />
    </div>
  );
};

export default HeatmapWithLegend;
